<template>
  <div id="exhibit-2">
    <BaseBanner v-bind="bannerProps" @onLoaded="onLoaded"></BaseBanner>

    <!-- Tutorial Overlay -->
    <TutorialOverlay
      v-if="tutorial.isActive.value"
      :current-step="tutorial.currentStep.value"
      :current-step-index="tutorial.currentStepIndex.value"
      :total-steps="tutorial.totalSteps.value"
      :target-rect="tutorial.targetRect.value"
      :is-first-step="tutorial.isFirstStep.value"
      :is-last-step="tutorial.isLastStep.value"
      @prev="tutorial.prevStep"
      @next="tutorial.nextStep"
      @go-to-step="tutorial.goToStep"
    />

    <!-- Wrong Page Popup -->
    <TutorialWrongPagePopup
      :show="tutorial.showWrongPagePopup.value"
      :page-name="tutorial.correctPageDisplayName.value"
      :target-component="tutorial.correctPageComponentName.value"
      @change-judge="handleChangeJudge"
    />

    <main class="content">
      <section class="content">
        <div class="search-block"
             :style="{ 'background-image': `url(${background.mainBg})` }">
          <Search @search-query="searchExhibit"
                  customPlaceholder="證物搜尋"
                  searchText="證物搜尋"></Search>
        </div>
        <div class="process"
             :style="{ 'background-image': `url(${background.mainBg})` }">
          <img :src="icon.search" />
          <span><b>{{ foundTotalExhibitNum }}</b>/{{ totalExhibitNum }}</span>
          <b-button type="is-info is-light" @click="sharedOwnExhibits">分享證物</b-button>
        </div>
        <div class="exhibit-list"
             :style="{ 'background-image': `url(${background.mainBg})` }"
             :class="{ reverse: selectExhibitCate === 'found' }">
          <div class="cate__content default" v-show="defaultExhibits.length > 0" :style="computedDefaultStyles">
            <ul id="default-exhibit-list">
              <li v-for="exhibit in defaultExhibits"
                  :key="exhibit.tag"
                  :class="{ active: exhibit.tag === selectExhibit.tag }"
                  :style="{
                    'background-image': `url(${
                      exhibit.tag === selectExhibit.tag ? icon.exhibitDefaultActive : icon.exhibitDefault
                    })`
                  }">
                <a @click="setSelectExhibit('default', exhibit.tag)">
                  {{ exhibit.name }}
                </a>
              </li>
            </ul>
            <div class="detail"
                 :class="{
                   'not-active': selectExhibitCate !== 'default',
                 }"
                 :style="{ 'background-image': `url(${icon.exhibitDefaultBG})` }">
              <p v-if="found"
                 class="detail__text"
                 v-html="changeLine(selectExhibit.report)"></p>
              <p v-else class="detail__text">查無此物</p>
              <a v-if="totalExhibitNum != foundTotalExhibitNum"
                 @click="userTool()"
                 class="tool">
                <img :src="icon.tool" />
                <p>使用蛋糕</p>
              </a>
            </div>
          </div>
          <div class="cate__content found" v-show="foundExhibits.length > 0" :style="computedFoundStyles">
            <ul id="found-exhibit-list">
              <li v-for="exhibit in foundExhibits"
                  :key="exhibit.tag"
                  :class="{ active: exhibit.tag === selectExhibit.tag }"
                  :style="{
                    'background-image': `url(${
                      exhibit.tag === selectExhibit.tag ? icon.exhibitFoundActive : icon.exhibitFound
                    })`,
                  }">
                <a @click="setSelectExhibit('found', exhibit.tag)">
                  {{ exhibit.name }}
                </a>
              </li>
            </ul>
            <div class="detail"
                 :class="{ 'not-active': selectExhibitCate !== 'found' }"
                 :style="{ 'background-image': `url(${icon.exhibitFoundBg})` }">
              <p v-if="found"
                 class="detail__text"
                 v-html="changeLine(selectExhibit.report)"></p>
              <p v-else class="detail__text">查無此物</p>
              <a v-if="totalExhibitNum != foundTotalExhibitNum"
                 @click="userTool()"
                 class="tool">
                <img :src="icon.tool" />
                <p>使用蛋糕</p>
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
    <b-modal v-model="useToolPopup">
      <div class="tool-modal">
        <img :src="icon.tool" /> <br />
        <h4>蛋糕</h4>
        <span>剩餘數量：{{ toolNum }}</span>
        <p v-if="toolNum != 0">確定把<strong>蛋糕</strong>交給察微判官魅嵐？</p>
        <p v-else>Oops! <strong>蛋糕</strong>好像用完了</p>
        <div class="modal__footer">
          <a class="cancel" @click.prevent="useToolPopup = false">
            再想想
          </a>
          <a v-if="toolNum != 0" class="accept" @click.prevent="accept()">
            交給她
          </a>
          <a v-else
             class="accept"
             :href="'https://liff.line.me/1653951718-o9GNrmEd?group_id=' + groupId">
            現在買
          </a>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import BaseBanner from '../../shared/baseBanner';
import Search from '../../shared/search.vue';
import { TutorialOverlay, TutorialWrongPagePopup } from '../../components/tutorial';
import { useExhibitsPage } from './useExhibitsPage';

/**
 * Refactored Exhibits page using composition API
 * Template structure matches original index.vue exactly to prevent style mismatch
 */
export default {
  name: 'ExhibitPage',

  components: {
    BaseBanner,
    Search,
    TutorialOverlay,
    TutorialWrongPagePopup
  },

  props: ['memberLineId', 'memberName', 'groupId', 'updateGroupStoryShip', 'updateFinishedDemo'],

  emits: ['change-judge'],

  setup(props, { emit }) {
    const exhibitsState = useExhibitsPage(props);

    const handleChangeJudge = (componentName) => {
      emit('change-judge', componentName);
    };

    return {
      ...exhibitsState,
      handleChangeJudge
    };
  }
};
</script>

<style lang="scss" src="./style.scss"></style>
